import {Api} from "../config/request";

const getBonusPoints =  async(data)=>{
    let response= await Api.PostRequest("/userBonusesDetails", data);
    return (response.data);
}

const claimBonusPoint = async(data)=>{
    let response= await Api.PostRequest("/claimBonus", data);
    return (response.data);
}

// const claimAllBonusPoints = async(data) => {
//     let response= await Api.PostRequest("/claimAllBonusPoints", data);
//     return (response.data);
// }

const getCurrentPolls = async(data) => {
    let response= await Api.PostRequest("/getPollsForSeasonOrGame", data);
    return (response.data);
}

const submitPollAnswer = async(data) => {
    let response= await Api.PostRequest("/submitPollAnswer", data);
    return (response.data);
}

const getPreviousPolls = async(data) => {
    let response= await Api.PostRequest("/getPollsForSeasonOrGame", data);
    return (response.data);
}

const getLivePolls = async(data) => {
    let response= await Api.PostRequest("/getPollsForSeasonOrGame", data);
    return (response.data);
}

const earnPointsApi= {
    getBonusPoints,
    claimBonusPoint,
    // claimAllBonusPoints,
    getCurrentPolls,
    submitPollAnswer,
    getPreviousPolls,
    getLivePolls
}
export default earnPointsApi;